const API_CALL = "generalSettings/API_CALL";
const CREATE_SETTINGS = "generalSettings/CREATE_SETTINGS";
const UPDATE_SETTINGS = "generalSettings/UPDATE_SETTINGS";
const GET_SETTINGS = "generalSettings/GET_SETTINGS";
const SET_SETTINGS = "generalSettings/SET_SETTINGS";
const RESET_SETTINGS = "generalSettings/RESET_SETTINGS";

export default {
    API_CALL,
    CREATE_SETTINGS,
    UPDATE_SETTINGS,
    GET_SETTINGS,
    SET_SETTINGS,
    RESET_SETTINGS
}